<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form"  :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="16">
						<el-form-item label="名称" prop="name"><el-input readonly v-model="formParameter.name"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="状态" prop="state">
							<select-option-dictionary readonly placeholder="请选择状态" v-model="formParameter.state"
								dkey="tst-state"></select-option-dictionary>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="所属产品" prop="productid">
							<el-select readonly v-model="formParameter.productid" placeholder="选择所属产品"
								@change="isUserChangeProduct = true">
								<el-option v-for="(itm, index) in inProducts" :key="index" :label="itm.name"
									:value="itm.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="发布人" prop="publisher">
							<el-select readonly v-model="publisher" placeholder="选择发布人">
								<el-option v-for="(itm, index) in inPublisher" :key="index" :label="itm.name"
									:value="itm.usrid">
								</el-option>
							</el-select></el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="执行人" prop="executor">
							<el-select readonly v-model="executor" placeholder="选择执行人">
								<el-option v-for="(itm, index) in inPublisher" :key="index" :label="itm.name"
									:value="itm.usrid">
								</el-option>
							</el-select></el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="24">
						<el-form-item label="字符含义" prop="charMean">
							<el-input :placeholder="charMeanDemo" v-model="formParameter.charMean" type="textarea"
								:rows="4" autocomplete="off" readonly></el-input>

						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
						<el-col :span="24">
							<el-form-item label="开始时间" prop="createTime"><el-input v-model="formParameter.createTime" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
				<el-row>
						<el-col :span="24">
							<el-form-item label="结束时间" prop="endTime"><el-input v-model="formParameter.endTime" autocomplete="off"></el-input></el-form-item>
						</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="方案步骤" prop="remarks">
                                             <div v-html="formParameter.remarks"></div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="'添加' != title">
					<el-col :span="24">
						<el-form-item label="结论" prop="conclusion">
							    <div v-html="formParameter.conclusion"></div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/product/tst/testplan/testplan.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';


export default {
	name: 'edit',
	components: {
		popup, selectOptionDictionary
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			inProducts: [],
			inPublisher: [],
			isUserChangeProduct: false,
			publisher: '',
			executor: '',
			isUpdtWedit: false, //用于更新wangEdit
			title: '', // 初始化,解决title报错问题
			charMeanDemo: `{    
    key1:格式演示1,key2:格式演示2,...
}`,
			rules: {
				//测试计划名称
				name: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					// if(!field.pk){如果不是日期；类型
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
					//   }
				],
				//属于哪个产品
				productid: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					// if(!field.pk){如果不是日期；类型
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
					//   }
				]



			}
		};
	},

	watch: {
		"formParameter.productid"(newVal, oldVal) {
			// 1. 没选产品 → 清空
			if (!newVal) {
				this.inPublisher = [];
				this.publisher = "";
				this.executor = "";
				return;
			}

			// 关键：只有【用户手动切换】才自动选第一个
			// 打开数据、代码赋值 → 不自动覆盖！
			// ==========================================
			if (this.isUserChangeProduct) {
				this.getPublisher(true);
			} else {
				this.getPublisher(false);
			}

			// 重置标记
			this.isUserChangeProduct = false;
		},
	},
	methods: {

		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.title = title
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (!this.parameter.id) {

					//添加
					this.formParameter.publisher = this.publisher
					this.formParameter.executor = this.executor

					let parameter = this.$utils.merger(this.formParameter);

					api.saveApi(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					this.formParameter.publisher = this.publisher
					this.formParameter.executor = this.executor
					//编辑
					let parameter = this.$utils.merger(this.formParameter);

					api.updateApi(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},

		getPublisher(autoSelectFirst) {
			let pid = this.formParameter.productid;
			if (!pid) return;

			// 先清空列表
			this.inPublisher = [];
			api.listPublishersApi({ id: pid }, response => {
				this.inPublisher = response.data;
				if (autoSelectFirst && this.inPublisher.length > 0) {
					this.publisher = this.inPublisher[0].usrid;
					this.executor = this.inPublisher[0].usrid;
				} else if (this.inPublisher.length == 0) {
					this.publisher = '';
					this.executor = '';
				}
			}), (err) => {
				console.log("获取发布人失败", err);
			};

		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};


			this.inPublisher = [];
			//清楚校验
			this.$refs.form.clearValidate();


			//查询所有进行中的产品
			api.listProductsApi({}, response => {
				this.inProducts = response.data;
			}, (err) => {
				console.log("❌ 失败", err);
			});

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toupdtApi(parameter, response => {
					if (response.data) {
						this.formParameter = response.data;
						//wangWedit 绑定数据 bug
						this.isUpdtWedit = true;
						setTimeout(() => {
							this.isUpdtWedit = false
						}, 45);
						this.getPublisher(false);
						this.publisher = this.formParameter.publisher;
						this.executor = this.formParameter.executor;
						this.popupLoading = false;
						console.log(this.formParameter);
					}
				});
			} else {
				//添加
				this.popupLoading = false;
			}

		},


	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
